import { Lightbulb } from "lucide-react";

export default function QuickAnswerSection() {
  return (
    <section className="py-16 lg:py-24">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="font-heading font-bold text-3xl lg:text-4xl mb-6">
          What Is the Highest Efficiency Solar Cell?
        </h2>

        <div className="prose prose-lg max-w-none text-muted-foreground space-y-4">
          <p>
            Solar cell efficiency measures how much sunlight a cell can convert into usable electricity. 
            A solar cell with 25% efficiency, for example, turns one quarter of the sunlight hitting it into electrical energy.
          </p>
          <p>
            In laboratory settings, researchers have achieved solar cell efficiencies above 47% using multi-junction cells. 
            However, these cutting-edge cells are expensive and not available to everyday consumers.
          </p>
          <p>
            For most buyers, the practical question isn't which solar cell has the absolute highest lab efficiency — 
            it's which commercially available solar panel delivers the best real-world output for their needs. 
            High-efficiency monocrystalline panels, bifacial panels, and PERC/TOPCon/HJT cells represent the best 
            consumer-grade technologies today, typically achieving 20–24% efficiency.
          </p>
        </div>

        {/* Callout Box */}
        <div className="mt-8 bg-accent/10 border-l-4 border-accent rounded-r-xl p-6 lg:p-8">
          <div className="flex gap-4">
            <Lightbulb className="w-6 h-6 text-accent shrink-0 mt-0.5" />
            <p className="text-base font-medium leading-relaxed">
              For most buyers, the best choice is not just the highest lab efficiency number — it is the solar panel 
              that gives the best real-world output for your space, budget, and power needs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}